import { config, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { IAccount } from "../types";
import { ICustomer } from "@/modules/banks/types";

config.rawError = true;

@Module({ namespaced: true })
export default class AccountModule extends VuexModule {
  account?: IAccount = undefined;
  customer?: ICustomer = undefined;
  token?: string = undefined;

  get isLoggedIn(): boolean {
    return this.account != undefined;
  }

  @Mutation
  setAccount(account: IAccount) {
    this.account = account;
    localStorage.setItem("account", JSON.stringify(this.account));
  }

  @Mutation
  setCustomer(customer: ICustomer) {
    this.customer = customer;
    localStorage.setItem("customer", JSON.stringify(this.customer));
  }

  @Mutation
  setToken(token: string) {
    this.token = token;
    localStorage.setItem("token", this.token!);
  }

  @Mutation
  getAccount() {
    if (localStorage.getItem("account") != null) {
      this.account = JSON.parse(localStorage.getItem("account")!);

      this.customer = JSON.parse(localStorage.getItem("customer")!);
    }
  }

  @Mutation
  getToken() {
    if (localStorage.getItem("token") != null)
      this.token = localStorage.getItem("token")!;
  }

  @Mutation
  clear() {
    this.account = undefined;
    this.customer = undefined;
    this.token = undefined;
  }
}
